import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Dropdown extends Component {

  constructor(props) {
    super(props)
    this.onChange = props.onChange.bind(this)
  }

  render() {
    const { htmlId, htmlName, value, children, className, showInvalid, disabled, widthCss} = this.props
    
    return (
      <div className={`${className} relative`}> 
        <select
          id={htmlId}
          name={htmlName}
          onChange={this.onChange}
          value={value}
          className={`${className} ${showInvalid ? 'border-red' : 'border-grey-light hover:border-blue-darkest'} block appearance-none ${widthCss || 'w-full'} bg-white border px-4 py-2 pr-8 rounded-full leading-tight focus:outline-none`}
          disabled={disabled}
        >
          {children}
        </select>
        <div className="pointer-events-none absolute pin-y pin-r flex items-center px-4 text-harbor">
          <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
    )
  }
}

Dropdown.propTypes = {
  htmlId: PropTypes.string.isRequired,
  htmlName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  showInvalid: PropTypes.bool,
  disabled: PropTypes.bool
}

Dropdown.defaultProps = {
  value: "",
  className: "",
  showInvalid: false,
  disabled: false
}

export default Dropdown